import React, { Component } from 'react';
import * as styled from './shop.styled';
import * as shop from '../../controllers/shop';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLoader} from "@fortawesome/pro-duotone-svg-icons";
import {shopItemContainer, shopItemData, shopItemsGrid, shopItemTitle} from "./shop.styled";
import ShopDetail from "../shopDetail/shopDetail";
import Cart from "../cart/cart";

class Shop extends Component {

    constructor() {
        super();
        this.state = {
            loaded: false,
            products: [],
            selectedProduct: null
        };
        this.shopDetailRef = React.createRef();
        this.cartRef = React.createRef();
    }

    componentDidCatch(){}

    componentDidMount() {
        this.loadProducts();
    }

    async loadProducts() {
        let products = await shop.loadProducts();
        this.setState((state) => {
            return {
                ...state,
                loaded: true,
                products
            };
        });
    }

    openShopItemDetail(selectedProduct) {
        this.setState((state) => {
            return {
                ...state,
                selectedProduct
            };
        }, () => {
            this.shopDetailRef.current.open(selectedProduct);
        });
    }

    render() {
        return (
            <styled.ShopContainer style={{height: `${this.props.screenHeight}px`}} className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                <styled.title>
                    Shop
                </styled.title>
                {
                    this.state.loaded ?
                        <>
                            <styled.shopItemsGrid>
                                {
                                    this.state.products.map((data, index) => {
                                        let img = data.images[0].image_data;
                                        return (
                                            <styled.shopItemContainer
                                                key={index}
                                                onClick={this.openShopItemDetail.bind(this, data)}
                                            >
                                                <div>
                                                    <img src={img.url} alt={img.name} />
                                                </div>
                                                <styled.shopItemData>
                                                    <div>
                                                        <styled.shopItemTitle>
                                                            {data.product.item_data.name}
                                                        </styled.shopItemTitle>
                                                    </div>
                                                    <div>
                                                        <styled.shopItemTitle>
                                                        </styled.shopItemTitle>
                                                    </div>
                                                </styled.shopItemData>
                                            </styled.shopItemContainer>
                                        )
                                    })
                                }
                            </styled.shopItemsGrid>
                            <Cart ref={this.cartRef} products={this.state.products} />
                            <ShopDetail
                                ref={this.shopDetailRef}
                                onCartChanged={() => {this.cartRef.current.loadCart();}}
                                onCartOpenRequest={() => {this.cartRef.current.setOpen(true);}}
                            />
                        </>
                        :
                        <FontAwesomeIcon className={'loadingIcon'} icon={faLoader} spin />
                }
            </styled.ShopContainer>
        );
    }
}

export default Shop;
